import { render, staticRenderFns } from "./deleteimage.html?vue&type=template&id=5422c4a5&scoped=true&"
import script from "./deleteimage.vue?vue&type=script&lang=js&"
export * from "./deleteimage.vue?vue&type=script&lang=js&"
import style0 from "./deleteimage.vue?vue&type=style&index=0&id=5422c4a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422c4a5",
  null
  
)

export default component.exports